import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import 'react-phone-number-input/style.css'
import { Link, Redirect } from "react-router-dom"
import ActionButton from "../common/button/actionbutton.component.jsx"
import ConfirmButton from "../common/button/confirmbutton.component.jsx"
import GlobalHelper from "../common/GlobalHelper.jsx"
import Icon from "../common/icon/icon.component.jsx"
import EmailInput from '../common/inputs/EmailInputComponent.tsx'
import PhoneNumberInput from '../common/inputs/PhoneNumberInputComponent.tsx'
import LabelSelect from '../common/label/selection.component.jsx'
import TaxSelect from '../common/pricing/taxselect.component.jsx'
import PaymentTermSelect from '../payment-term/locationselect.component.jsx'
import { Guard, Permissions } from '../role/Guard.jsx'
import { ContactFormService } from '../state/contact/services/ContactFormService'
import { TYPE_CUSTOMER_TAG } from '../state/label/labelTypes'
import AddressFormFields from "./components/AddressFormFieldsComponent"
import './customerForm.styles.css'
import CustomerSelect from './selection.component.jsx'

const messages = defineMessages({
    "contact_title_mr": {
        id: 'customer.modal.placeholder.contact_title_mr',
        defaultMessage: 'Mr',
    },
    "contact_title_ms": {
        id: 'customer.modal.placeholder.contact_title_ms',
        defaultMessage: 'Ms',
    },
    "contact_last_name_placeholder": {
        id: 'customer.modal.placeholder.contact_last_name',
        defaultMessage: 'Enter contact last name',
    },
    "contact_first_name_placeholder": {
        id: 'customer.modal.placeholder.contact_first_name',
        defaultMessage: 'Enter contact first name',
    },
    "email_placeholder": {
        id: 'customer.modal.placeholder.email',
        defaultMessage: 'Enter email',
    },
    "primary_phone_number_placeholder": {
        id: 'customer.modal.placeholder.primary_phone_number',
        defaultMessage: 'Enter primary phone number',
    },
    "mobile_phone_number_placeholder": {
        id: 'customer.modal.placeholder.mobile_phone_number',
        defaultMessage: 'Enter mobile phone number',
    },
    "tax_number_placeholder": {
        id: 'user.form.edit.tax_number',
        defaultMessage: 'Enter Tax number',
    },
    "language_dropdown_fr": {
        id: 'customer.drowpdown.language.fr',
        defaultMessage: 'French',
    },
    "language_dropdown_en": {
        id: 'customer.drowpdown.language.en',
        defaultMessage: 'English',
    },
    "user.form.edit.language_choose": {
        id: 'user.form.edit.language_choose',
        defaultMessage: 'Choose language',
    },
    "user.form.edit.language_english_us": {
        id: 'user.form.edit.language_english_us',
        defaultMessage: 'English US',
    },
    "user.form.edit.language_english_ca": {
        id: 'user.form.edit.language_english_ca',
        defaultMessage: 'English Canada',
    },
    "user.form.edit.language_french_ca": {
        id: 'user.form.edit.language_french_ca',
        defaultMessage: 'French Canada',
    },
    "emailKeyword": {
        id: "contact.form.edit.duplication_error_message_email",
        defaultMessage: "Contact using this email already exists:",
    },
    "phoneNumberKeywordCheckDup": {
        id: "contact.form.edit.duplication_error_message_phone",
        defaultMessage: "Contact using this phone number already exists:",
    }

})

class CustomerForm extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            advancedForm: this.props.contactId !== '', //by default, we show the short version of the form
            contactId: '',
            contactTitle: '',
            contactFirstName: '',
            contactLastName: '',
            contactEmail: '',
            contactPrimaryPhoneNumber: '',
            contactPrimaryPhoneNumberisValid: true,
            contactPrimaryPhoneNumberExtension: '',
            contactPhoneNumberMobile: '',
            contactPhoneNumberMobileisValid: true,
            contactLanguage: AppContext.getLocale().getLanguage(),
            contactNotes: '',
            checkValidForm: false,
            address: {
                addressId: '',
                street: '',
                street2: '',
                city: '',
                postalCode: '',
                state: '',
                stateCode: '',
                country: '',
                countryCode: '',
            },
            contactDeletedAt: '',
            companyIdentifier: this.props.companyIdentifier ? props.companyIdentifier : '',
            taxId: '',
            cancelRedirectPath: this.props.cancelRedirectPath ? props.cancelRedirectPath : '/contacts/listing',
            saveRedirectPath: this.props.saveRedirectPath ? props.saveRedirectPath : '',
            allowCreateCompany: true,
            addressOnly: this.props.addressOnly || false,
            formStatus: '',
            defaultCountryCode: '',
            labelIds: [],
            playerTypeId: [],
            customerTypeId: null,
            saveLoading: false,
            unarchiveLoading: false,
            emailKeyword: [],
            taxNumber: '',

        }

        this.filterDuplicateList = this.filterDuplicateList.bind(this)
        this.openAdvanced = this.openAdvanced.bind(this)
        this.save = this.save.bind(this)
        this.deleteContact = this.deleteContact.bind(this)
        this.unarchiveContact = this.unarchiveContact.bind(this)
        this.saveCustomer = this.saveCustomer.bind(this)
        this.validateCustomerForm = this.validateCustomerForm.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleCompanyName = this.handleCompanyName.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.checkForDuplicate = this.checkForDuplicate.bind(this)
        this.checkDuplicateEmailList = this.checkDuplicateEmailList.bind(this)
        this.handlePrimaryPhoneChange = this.handlePrimaryPhoneChange.bind(this)
        this.handleMobilePhoneChange = this.handleMobilePhoneChange.bind(this)
        this.validPhoneNumber = this.validPhoneNumber.bind(this)
        this.shopifyDuplicateCheckOnSave = this.shopifyDuplicateCheckOnSave.bind(this)
        this.handleAddressChange = this.handleAddressChange.bind(this)
        this.fetchDefaultCountryAndStateCode = this.fetchDefaultCountryAndStateCode.bind(this)
    }

    componentDidMount() {
        let contactId = ''
        if (this.props.contactId) {
            contactId = this.props.contactId
        }

        if (contactId) {

            let contact = null
            AppContext.getApiClient().get('/contacts/' + contactId).then(r => {
                contact = r
                if (r.type === 'persons' && r.attributes.organizationId) {
                    return AppContext.getApiClient().get('/contacts/' + r.attributes.organizationId)
                }
                return Promise.resolve(null)
            }).then(o => {
                let contactPrimaryPhoneNumber = ''
                let contactPrimaryPhoneNumberExtension = ''
                let contactMobilePhoneNumber = ''
                for (let i = 0; i < contact.attributes.phoneNumbers.length; i++) {
                    if (contact.attributes.phoneNumbers[i]["type"] === "primary") {
                        contactPrimaryPhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                        contactPrimaryPhoneNumberExtension = contact.attributes.phoneNumbers[i]["extension"]
                    }
                    if (contact.attributes.phoneNumbers[i]["type"] === "mobile") {
                        contactMobilePhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                    }
                }

                const billingAddress = contact.attributes.address || {}
                this.setState({
                    contactId: contactId,
                    contactTitle: contact.attributes.title,
                    contactFirstName: contact.attributes.firstName,
                    contactLastName: contact.attributes.lastName,
                    contactEmail: contact.attributes.email,
                    contactPrimaryPhoneNumber: contactPrimaryPhoneNumber,
                    contactPrimaryPhoneNumberisValid: GlobalHelper.isValidPhoneNumberInput(contactPrimaryPhoneNumber),
                    contactPrimaryPhoneNumberExtension: contactPrimaryPhoneNumberExtension,
                    contactPhoneNumberMobile: contactMobilePhoneNumber,
                    contactPhoneNumberMobileisValid: GlobalHelper.isValidPhoneNumberInput(contactMobilePhoneNumber),
                    contactLanguage: contact.attributes.language,
                    contactNotes: contact.attributes.notes,
                    companyIdentifier: contact.attributes.organizationId,
                    contactType: contact.type,
                    contactDeletedAt: contact.attributes.deletedAt,
                    labelIds: contact.attributes.labelIds,
                    playerTypeId: contact.attributes.labels.filter(l => l.attributes.type === TYPE_CUSTOMER_TAG).map(l => l.id) || null,
                    taxId: contact.attributes.taxId,
                    paymentTermId: contact.attributes.paymentTermId,
                    customerTypeId: contact.attributes.labels.filter(l => l.attributes.type === 'customer-type').map(l => l.id)[0] || null,
                    taxNumber: contact.attributes.taxNumber,
                    address: {
                        ...billingAddress
                    },
                }, () => {
                    if (!this.state.address.countryCode) {
                        this.fetchDefaultCountryAndStateCode()
                    }
                })
            })
        } else {
            this.fetchDefaultCountryAndStateCode()
        }
    }

    fetchDefaultCountryAndStateCode() {
        //fetch the default country/state from the company details
        AppContext.getApiClient().get('/accounts/company-descriptions').then((result) => {
            let defaultCountryCode = result.attributes.organization.attributes.address.countryCode
            let country = GlobalHelper.getCountryLocalizedName(defaultCountryCode, AppContext.getLocale().getLanguageWithoutRegionCode())
            this.setState({
                defaultCountryCode: defaultCountryCode,
                address: {
                    ...this.state.address,
                    country: country,
                    countryCode: defaultCountryCode
                },
            });
        })
    }

    openAdvanced(event) {
        event.preventDefault()
        this.setState({
            advancedForm: true
        })
    }

    deleteContact(event) {
        AppContext.getApiClient().delete('/contacts/' + this.state.contactId).then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect to={{ pathname: '/contacts/listing' }} />
            }
            this.setState({ formStatus: formStatus })
        })

        event.preventDefault()
    }

    unarchiveContact(event) {
        AppContext.getApiClient().put('/contacts/' + this.state.contactId + '/unarchive', {}).then(q => {
            this.setState({
                unarchiveLoading: true,
            })
            this.loadContact(event.getData().contactId)
            this.setState({
                unarchiveLoading: true,
            })
        })
    }

    save() {
        this.setState({
            saveLoading: true,
            checkValidForm: true,
        })
        if (!this.validateCustomerForm() ||
            !this.state.contactPhoneNumberMobileisValid ||
            !this.state.contactPrimaryPhoneNumberisValid) {//prevent saving if the customer form is not filled out properly
            this.setState({
                saveLoading: false,
            })
            return
        }

        this.saveCustomer().then((response) => {
            let formStatus = ''
            if (response.error) {
                formStatus = <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <FormattedMessage
                        id="customer.modal.add_form.error_message"
                        defaultMessage="Error! {errorMessage}"
                        values={{ errorMessage: response.error.message }}
                    />
                </div>
                this.setState({ formStatus: formStatus })
            } else {
                //if the person created was associated to a new company, we make sure we return the person instead of the organization
                let customerId = response.id
                if (response.type === "organizations" && response.attributes.persons && response.attributes.persons[0]) {
                    customerId = response.attributes.persons[0].id
                }
                formStatus = <Redirect to={{
                    pathname: this.state.saveRedirectPath || '/contacts/' + customerId + '/details',
                    state: {
                        contactId: customerId
                    }
                }} />
                this.setState({ formStatus: formStatus, customerId: customerId })
            }
            this.setState({
                saveLoading: false,
                checkValidForm: false,
            })
        })
    }

    validateCustomerForm() {
        let form = document.getElementById("customer-form")
        const checkResult = form.checkValidity()
        form.classList.add('was-validated')
        return checkResult
    }

    handleCompanyName(companyID) {//companyID may be a full company name instead of an ID when the user tries to create a new company
        this.setState({
            companyIdentifier: companyID ? companyID : ''
        })
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value,
        })
    }

    validPhoneNumber() {
        let formattedPhoneNumber = GlobalHelper.formatPhoneNumberDigitOnly(this.state.contactPrimaryPhoneNumber)
        return formattedPhoneNumber.length >= 10;
    }

    handlePrimaryPhoneChange(phoneNumber, isValidPhoneNumber) {
        this.setState({
            contactPrimaryPhoneNumber: phoneNumber,
            contactPrimaryPhoneNumberisValid: isValidPhoneNumber,
        }, () => {
            if (phoneNumber && this.validPhoneNumber()) {
                this.checkForDuplicate('phoneNumberKeywordCheckDup',
                    GlobalHelper.formatPhoneNumberDigitOnly(this.state.contactPrimaryPhoneNumber))
            } else {
                this.setState({
                    phoneNumberKeywordCheckDup: ''
                })
            }
        })

    }


    handleMobilePhoneChange(phoneNumber, isValidPhoneNumber) {
        this.setState({
            contactPhoneNumberMobileisValid: isValidPhoneNumber,
            contactPhoneNumberMobile: phoneNumber,
        })
    }

    getPostData(warningMessage, value) {
        let postData = {
            keywords: value,
            objects: ['contacts'],
            fields: [warningMessage],
            pageSize: 5,
            activePage: 1,
            sortByField: 'createdAt',
            sortAsc: true,
            lightResult: true,
            filters: {},
        }
        if (typeof value != 'string') {
            postData.keywords = '*'
            postData.filters[[warningMessage]] = value
        }
        return postData
    }

    filterDuplicateList(duplicates) {
        return duplicates.data.filter(x => x.id !== this.state.contactId)
    }

    checkForDuplicate(warningMessage, value) {
        AppContext.getApiClient().post('/listing/search', this.getPostData(warningMessage, value)).then(res => {
            res = this.filterDuplicateList(res)
            if (res.length === 0) {
                this.setState({
                    [warningMessage]: ''
                })
            } else {
                this.setState({
                    [warningMessage]:
                        <div className="alert alert-warning" role="alert">
                            {this.props.intl.formatMessage(messages[warningMessage])}
                            &nbsp;
                            {res.map(element => <Link key={element.id} to={`/contacts/${element.id}/details`}
                                className="mr-1">{element.name}</Link>).reduce((prev, curr) => [prev, ", ", curr])}
                        </div>
                })
            }
        })
    }

    checkDuplicateEmailList() {
        let isValid = true;
        this.state.emailKeyword.filter(element => {
            if (!GlobalHelper.validateEmail(element)) {
                isValid = false;
            }
        })
        return isValid;
    }

    handleEmailChange(event) {
        const target = event.target.value
        this.setState({
            contactEmail: target,
            emailKeyword: target.split(','),
        }, () => {
            if (this.checkDuplicateEmailList()) {
                this.checkForDuplicate('emailKeyword', this.state.emailKeyword)
            } else {
                this.setState({
                    emailKeyword: ''
                })
            }
        })
    }

    saveCustomer() {
        const payloadPhoneNumbers = []
        if (this.state.contactPrimaryPhoneNumber) {
            payloadPhoneNumbers.push({
                type: "primary",
                phoneNumber: this.state.contactPrimaryPhoneNumber,
                extension: this.state.contactPrimaryPhoneNumberExtension

            })
        }
        if (this.state.contactPhoneNumberMobile) {
            payloadPhoneNumbers.push({
                type: "mobile",
                phoneNumber: this.state.contactPhoneNumberMobile,
                extension: ""
            })
        }

        let payloadPerson = {
            title: this.state.contactTitle,
            firstName: this.state.contactFirstName,
            lastName: this.state.contactLastName,
            email: this.state.contactEmail.trim(),
            phoneNumbers: payloadPhoneNumbers,
            language: this.state.contactLanguage,
            notes: this.state.contactNotes,
            labelIds: this.state.labelIds,
            taxId: this.state.taxId,
            paymentTermId: this.state.paymentTermId,
            taxNumber: this.state.taxNumber,
            address: {
                ...this.state.address,
                isDefault: true,
                addressType: 'billing',
                firstName: this.state.contactFirstName,
                lastName: this.state.contactLastName,
            },
        }

        return ContactFormService.SaveContact(this.state.contactId, this.state.companyIdentifier, payloadPerson, "persons")
    }

    shopifyDuplicateCheckOnSave() {
        return GlobalHelper.hasShopifyIntegration() &&
            (this.state.phoneNumberKeywordCheckDup || !(typeof this.state.emailKeyword.length === "number"))
    }

    handleAddressChange(change) {
        this.setState({
            address: {
                ...this.state.address,
                ...change,
            },
        })
    }

    render() {

        let hide = ''
        let advancedBtn = ''
        if (!this.state.advancedForm) {
            hide = 'd-none'
            advancedBtn = <div className="col-12 text-center pb-4">
                <button className="btn btn-outline-primary btn-sm" onClick={this.openAdvanced}>
                    <Icon value={"plus"} />
                    &nbsp;
                    <FormattedMessage
                        id="product.form.edit.advanced_btn"
                        defaultMessage="Open advanced form"
                    />
                </button>
            </div>
        }

        let organizationField = ''
        if (this.state.type !== 'organizations') {
            organizationField = <div className="form-row">
                <div className="col-md-12 p-2">
                    <label htmlFor="companyName">
                        <FormattedMessage
                            id="customer.modal.add_form.company_name_label"
                            defaultMessage="Company Name"
                        />
                    </label>
                    <CustomerSelect
                        value={this.state.companyIdentifier}
                        onChange={this.handleCompanyName}
                        contactType="organizations"
                        allowCreate={this.state.allowCreateCompany}
                    />
                </div>
            </div>
        }

        let deleteAction = ''
        if (this.state.contactDeletedAt) {
            deleteAction = [<div className="col-3" key={"1"}>
                <ActionButton className={"btn btn-sm btn-warning mr-2 mb-2"} onClick={this.unarchiveContact}
                    isLoading={this.state.unarchiveLoading}>
                    <FormattedMessage
                        id="customer.view.edit_unarchive_btn"
                        defaultMessage="Unarchive"
                    />
                </ActionButton>
            </div>,
            <div className="col-9" key={"2"}><FormattedMessage
                id="customer.edit_form.archived_customer_info"
                defaultMessage="This contact is archived and can't be found in search results."
            /></div>]
        } else if (this.state.contactId && Guard.isAuthorized(Permissions.DeleteContact)) {
            deleteAction = <ConfirmButton onModalRender={(m, c) => {
                this.setState({ formStatus: m }, c)
            }} onClick={this.deleteContact} className="btn btn-danger"
                identifier={this.state.contactFirstName + " " + this.state.contactLastName}>
                <FormattedMessage
                    id="customer.form.edit.delete_btn"
                    defaultMessage="Delete contact"
                />
            </ConfirmButton>
        }

        return (

            <div className="modal-body">
                <div className="container-fluid">
                    <form className="needs-validation" id="customer-form" noValidate>
                        <div className="row ui-module">
                            <div className="col-12">
                                <div className="form-row">
                                    <div className="col-md-2 p-2">
                                        <label htmlFor="contactTitle">
                                            <FormattedMessage
                                                id="customer.modal.add_form.contact_title_label"
                                                defaultMessage="Contact Title"
                                            />
                                        </label>
                                        <select value={this.state.contactTitle} className="custom-select mr-1"
                                            id="dropDownTitle" name="contactTitle" onChange={this.handleFormChange}>
                                            <option key="None" id="NoneTitle" value="">-</option>
                                            <option key="Mr" id="MrTitle"
                                                value="Mr">{this.props.intl.formatMessage(messages["contact_title_mr"])}</option>
                                            <option key="Ms" id="MsTitle"
                                                value="Ms">{this.props.intl.formatMessage(messages["contact_title_ms"])}</option>
                                        </select>
                                    </div>
                                    <div className="col-md-5 p-2">
                                        <label htmlFor="contactFirstName">
                                            <FormattedMessage
                                                id="customer.modal.add_form.contact_first_name_label"
                                                defaultMessage="First Name"
                                            />
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="contactFirstName"
                                            name="contactFirstName"
                                            value={this.state.contactFirstName}
                                            placeholder={this.props.intl.formatMessage(messages["contact_first_name_placeholder"])}
                                            onChange={this.handleFormChange}
                                        />
                                    </div>
                                    <div className="col-md-5 p-2">
                                        <label htmlFor="contactLastName">
                                            <FormattedMessage
                                                id="customer.modal.add_form.contact_last_name_label"
                                                defaultMessage="Contact Last Name"
                                            />
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="contactLastName"
                                            name="contactLastName"
                                            value={this.state.contactLastName}
                                            placeholder={this.props.intl.formatMessage(messages["contact_last_name_placeholder"])}
                                            onChange={this.handleFormChange}
                                            required />
                                        <div className="invalid-feedback">
                                            <FormattedMessage
                                                id="customer.modal.add_form.contact_last_name_field_error"
                                                defaultMessage="Contact last name is required"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {organizationField}
                                <div className="form-row">
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="email">
                                            <FormattedMessage
                                                id="customer.modal.add_form.email_label"
                                                defaultMessage="Email"
                                            />
                                        </label>
                                        <EmailInput
                                            type="text"
                                            className="form-control"
                                            id="email"
                                            name="contactEmail"
                                            email={this.state.contactEmail}
                                            placeholder={this.props.intl.formatMessage(messages["email_placeholder"])}
                                            handleFormChange={this.handleEmailChange}

                                        />
                                        <div className="invalid-feedback">
                                            <FormattedMessage
                                                id="customer.modal.add_form.email_field_error"
                                                defaultMessage="Please ensure the email is filled out properly"
                                            />
                                        </div>
                                    </div>
                                    {this.state.emailKeyword}
                                </div>

                                <div className="form-row">
                                    <div className="col-12 col-sm-9 p-2">
                                        <label htmlFor="primaryPhoneNumber">
                                            <FormattedMessage
                                                id="customer.modal.add_form.primary_phone_number_label"
                                                defaultMessage="Phone Number (Primary)"
                                            />
                                        </label>
                                        <PhoneNumberInput
                                            id="primaryPhoneNumber"
                                            checkValidForm={this.state.checkValidForm}
                                            name="contactPrimaryPhoneNumber"
                                            phoneNumber={this.state.contactPrimaryPhoneNumber}
                                            placeholder={this.props.intl.formatMessage(messages["primary_phone_number_placeholder"])}
                                            defaultCountry={this.state.address.countryCode}
                                            onChange={this.handlePrimaryPhoneChange}
                                            message={<FormattedMessage
                                                id="customer.modal.add_form.contactMobilePhoneNumber_field_error"
                                                defaultMessage="Please ensure the primary phone number is filled out properly"
                                            />}
                                        />
                                    </div>

                                    <div className="col-12 col-sm-3 pt-2">
                                        <label htmlFor="extensionPhoneNumber">
                                            <FormattedMessage
                                                id="customer.modal.add_form.primary_phone_number_extension_label"
                                                defaultMessage="Extension"
                                            />
                                        </label>
                                        <input type="text"
                                            className="form-control"
                                            name="contactPrimaryPhoneNumberExtension"
                                            placeholder="123"
                                            value={this.contactPrimaryPhoneNumberExtension}
                                            onChange={this.handleFormChange}
                                        />
                                    </div>
                                    {this.state.phoneNumberKeywordCheckDup}
                                </div>
                                <div className={"form-row " + hide}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="mobilePhoneNumber">
                                            <FormattedMessage
                                                id="customer.modal.add_form.mobile_phone_number_label"
                                                defaultMessage="Phone Number (Mobile)"
                                            />
                                        </label>
                                        <PhoneNumberInput
                                            id="mobilePhoneNumber"
                                            name="contactPhoneNumberMobile"
                                            phoneNumber={this.state.contactPhoneNumberMobile}
                                            checkValidForm={this.state.checkValidForm}
                                            placeholder={this.props.intl.formatMessage(messages["mobile_phone_number_placeholder"])}
                                            onChange={this.handleMobilePhoneChange}
                                            defaultCountry={this.state.address.countryCode}
                                            message={<FormattedMessage
                                                id="customer.modal.add_form.contactMobilePhoneNumber_field_error"
                                                defaultMessage="Please ensure the primary phone number is filled out properly"
                                            />}
                                        />
                                    </div>
                                </div>

                                {!hide &&
                                    <AddressFormFields value={this.state.address} onChange={this.handleAddressChange} />}

                                <div className={"form-row " + hide}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="contactLanguage">
                                            <FormattedMessage
                                                id="customer.modal.add_form.contact_language_label"
                                                defaultMessage="Contact Language"
                                            />
                                        </label>
                                        <select value={this.state.contactLanguage} className="custom-select mr-1"
                                            id="dropDownLanguage" name="contactLanguage"
                                            onChange={this.handleFormChange}>
                                            <option value="">
                                                {this.props.intl.formatMessage(messages['user.form.edit.language_choose'])}
                                            </option>
                                            {GlobalHelper.getSupportedLocales().map(locale => {
                                                return <option value={locale}>
                                                    {this.props.intl.formatMessage(GlobalHelper.getLanguageMessage(locale))}
                                                </option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className={"form-row " + hide}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="contactLanguage">
                                            <FormattedMessage
                                                id="customer.modal.add_form.customer_type_label"
                                                defaultMessage="Customer type"
                                            />
                                        </label>
                                        <LabelSelect
                                            creatable={true}
                                            type="customer-type"
                                            name="customerTypeId"
                                            value={this.state.customerTypeId}
                                            onChange={value => {
                                                this.setState({
                                                    labelIds: value ? [value].concat(this.state.playerTypeId) : this.state.playerTypeId, customerTypeId: value,
                                                })
                                            }}
                                            multi={false}
                                        />
                                    </div>
                                </div>
                                <div className={"form-row " + hide}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="playerTypeId">
                                            <FormattedMessage
                                                id="customer.modal.add_form.customer_tags"
                                                defaultMessage="Customer tags"
                                            />
                                        </label>
                                        <LabelSelect
                                            creatable={true}
                                            type="customer-tag"
                                            name="playerTypeId"
                                            value={this.state.playerTypeId}
                                            onChange={value => {
                                                this.setState({
                                                    playerTypeId: value ? value : [],
                                                    labelIds: value ? value.concat([this.state.customerTypeId]) : [this.state.customerTypeId]
                                                })
                                            }}
                                            multi={true}
                                        />
                                    </div>
                                </div>
                                <div className={"form-row " + hide}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="contactLanguage">
                                            <FormattedMessage
                                                id="customer.modal.add_form.default_payment_term_label"
                                                defaultMessage="Payment term"
                                            />
                                        </label>
                                        <PaymentTermSelect
                                            value={this.state.paymentTermId}
                                            onChange={paymentTermId => {
                                                this.setState({ paymentTermId: paymentTermId })
                                            }}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className={"form-row " + hide}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="contactLanguage">
                                            <FormattedMessage
                                                id="customer.modal.add_form.default_tax_label"
                                                defaultMessage="Default tax"
                                            />
                                        </label>
                                        <TaxSelect
                                            value={this.state.taxId}
                                            onChange={taxId => {
                                                this.setState({ taxId: taxId })
                                            }}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className={hide}>
                                    <div className="col-mb-12 p-2">
                                        <label htmlFor="taxNumber">
                                            <FormattedMessage
                                                id="customer.modal.add_form.contact_tax_number_label"
                                                defaultMessage="Tax number (optional)"
                                            />
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="taxNumber"
                                            name="taxNumber"
                                            value={this.state.taxNumber}
                                            placeholder={this.props.intl.formatMessage(messages["tax_number_placeholder"])}
                                            onChange={this.handleFormChange} />
                                    </div>
                                </div>
                                <div className={"form-row " + hide}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="contactNotes">
                                            <FormattedMessage
                                                id="customer.modal.add_form.contact_note_label"
                                                defaultMessage="Notes"
                                            />
                                        </label>
                                        <textarea className="form-control"
                                            id="customerNotes"
                                            name="contactNotes"
                                            onChange={this.handleFormChange}
                                            value={this.state.contactNotes}
                                            rows="5">
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    {advancedBtn}
                    <div className="col-12 mb-5">
                        {this.state.formStatus}
                    </div>
                    <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                        <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                            <div className="col-12 ui-module sticky-bottom-module">
                                <div className="row ">
                                    <div className="col-12 col-sm-6 text-align-left">
                                        {deleteAction}
                                    </div>
                                    <div className="col-12 col-sm-6 text-align-right">
                                        <Link to={this.state.cancelRedirectPath} className="btn btn-light">
                                            <FormattedMessage
                                                id="product.form.edit.cancel_btn"
                                                defaultMessage="Cancel"
                                            />
                                        </Link>
                                        &nbsp;
                                        &nbsp;

                                        <ActionButton onClick={this.save} className="btn btn-primary"
                                            isLoading={ this.state.saveLoading }
                                            type="submit"
                                            disabled={this.shopifyDuplicateCheckOnSave()}>
                                            <FormattedMessage
                                                id="product.form.edit.save_btn"
                                                defaultMessage="Save"
                                            />
                                        </ActionButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(CustomerForm);






// WEBPACK FOOTER //
// ./src/customer/customerForm.component.jsx